import React from "react";

const Section = () => {
  return (
    <div className="relative w-full flex h-full justify-center">
      <div className="bg-lightblue-3 md:h-[320px] p-4 w-full flex flex-col items-center">
        <div className="h-full relative max-w-screen-xl flex flex-wrap flex-col md:flex-row items-center w-full py-10 md:py-0">
          <a
            className="w-full md:w-1/3 flex flex-col items-center justify-center"
            href="tel:+61404509680"
          >
            <img
              src="/assets/images/icons/call.png"
              alt=""
              className="w-[80px] mb-8 animate-scale"
            />
            <p className="text-2xl text-blue-6 mb-4">Call Now</p>
            <p className="text-xl text-black">0404 509 680</p>
          </a>
          <a
            className="w-full md:w-1/3 flex flex-col items-center justify-center"
            href="mailto:info@clearchoicecs.com.au"
          >
            <img
              src="/assets/images/icons/email.png"
              alt=""
              className="w-[80px] mb-8 animate-scale"
            />
            <p className="text-2xl text-blue-6 mb-4">Email Us</p>
            <p className="text-xl text-black">info@clearchoicecs.com.au</p>
          </a>

          <a
            className="w-full md:w-1/3 flex flex-col items-center justify-center"
            target="_blank"
            rel="noopener noreferrer"
            href="https://maps.app.goo.gl/KW3gRPpLz3k5pjgQ8"
          >
            <img
              src="/assets/images/icons/location.png"
              alt=""
              className="w-[80px] mb-8 animate-scale"
            />
            <p className="text-2xl text-blue-6 mb-4">Address</p>
            <p className="text-xl text-black text-center">
              70 Hughes Crescent, Dandenong North, 3175
            </p>
          </a>
        </div>
      </div>
      <img
        src="/assets/images/contact/dash-arrow.png"
        alt=""
        className="w-[200px] absolute top-0 left-0 z-0 pointer-events-none"
      />
      <img
        src="/assets/images/contact/dash-arrow-1.png"
        alt=""
        className="w-[200px] absolute bottom-0 z-0 pointer-events-none"
      />
      <img
        src="/assets/images/contact/dash-arrow-2.png"
        alt=""
        className="w-[200px] absolute top-0 right-0 z-0 pointer-events-none"
      />
    </div>
  );
};

export default Section;
